import {type StateTree} from "pinia";
import {type UserStoreState} from "@/store/user/state";
import {UserV2Type} from "~~/package/mapper/user/model/UserType";
import {MemberMenuAccessRole} from '~~/package/mapper/organization/model/OrganizationMemeberTypes';

export interface UserStoreGetters extends StateTree {
    name: () => string;
    isAdminType: () => boolean;
    isSuperAdminType: () => boolean;
    isMemberType: () => boolean;
    isPermissionCreateAssessment: () => boolean;
    isPermissionManageAssessment: () => boolean;
    isActiveAdvance: () => boolean;
    isPermissionAdaptiveLecture: () => boolean;
}

export const getters =  {
    name(state: UserStoreState) {
        return state.firstName + 'name';
    },
    isAdminType(state: UserStoreState) {
        return state.userV2.orgInfo?.grades[0] === UserV2Type.ORG_ADMINISTRATOR;
    },
    isSuperAdminType(state: UserStoreState) {
        return state.userV2.orgInfo?.grades[0] === UserV2Type.ORG_SUPER_ADMINISTRATOR;
    },
    isMemberType(state: UserStoreState) {
        return state.userV2.orgInfo == null || state.userV2.orgInfo?.grades[0] === UserV2Type.ORG_MEMBER;
    },
    isPermissionCreateAssessment(state) {
        return state.userV2.accessRoles.includes(MemberMenuAccessRole.ROLE_SKILL_CERTIFY)
    },
    isPermissionManageAssessment(state) {
        return state.userV2.accessRoles.includes(MemberMenuAccessRole.ROLE_SKILL_MONITOR)
    },
    isActiveAdvance(state: UserStoreState) {
        return state.userV2.accessRoles.includes('ROLE_SKILL_ADVANCE' as MemberMenuAccessRole);
    },
    isPermissionAdaptiveLecture(state) {
        return state.userV2.accessRoles.includes(MemberMenuAccessRole.ROLE_ADAPTIVE_LECTURE);
    }
};
